import { Create, translate } from "react-admin";
import React from "react";

import RoomForm from "./RoomForm";

const RoomTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("room.room")}`}</span>;
};
const Title = translate(RoomTitle);

export const RoomCreate = props => {
  // console.log('boboboboob', props)
  return (
    <Create title={<Title />} {...props}>
      <RoomForm />
    </Create>
  );
};



// WEBPACK FOOTER //
// ./src/components/room/RoomCreate.js